module.exports = "data:image/webp;base64,UklGRmQAAABXRUJQVlA4IFgAAADwAwCdASoZABkAPpE+mkkloyKhKAqosBIJZwC3vJWAT/woW18Mse0AAP7hTADQrPLakqjio5YvTpKFG88rtPbGlNs4K7H41aq4prLobqioNAxPedPRQgAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/silver.webp
// module id = FWae
// module chunks = 14